import React from 'react';
import ImageSlider from '@common/components/imageSlider';

export default function Top() {
  return <ImageSlider />;
}
